module.exports = __webpack_public_path__ + "img/logo.6fe063b4.png";